"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledLabel = exports.StyledSelect = exports.SelectWrapper = void 0;

var _reactSelect = _interopRequireDefault(require("react-select"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
    DO NOT COPY PATTERNS FROM THIS FILE
    this component is a bit of a hack from a styling perspective.
    it does not fully support themes, and while they can be shoehorned in, reusability of our helpers is nearly impossible.

    one thing to look into is using the style prop described here: https://react-select.com/components#adjusting-the-styling
    the description there is a little light to say the least but it may allow for us to use the dropdown mixins tha we have already in place
 */
// External

/* eslint-disable indent */
var SelectWrapper = _styledComponents.default.div.withConfig({
  displayName: "Selectstyles__SelectWrapper",
  componentId: "ntlyl5-0"
})([""]);

exports.SelectWrapper = SelectWrapper;
var StyledSelect = (0, _styledComponents.default)(_reactSelect.default).withConfig({
  displayName: "Selectstyles__StyledSelect",
  componentId: "ntlyl5-1"
})(["&,& *{outline:none;font-family:", ";}padding:", " 0;.c-react-select__control{align-content:flex-start;border-color:transparent;border-bottom:", " solid ", ";border-radius:0;box-shadow:none;display:flex;margin-bottom:", ";width:100%;&.c-react-select__control--is-focused,&:hover{border-color:transparent;border-bottom:", " solid ", ";box-shadow:none;margin-bottom:", ";}&.c-react-select__control--menu-is-open .c-react-select__dropdown-indicator{transform:rotate(180deg);}}.c-react-select__value-container{cursor:", ";&.c-react-select__value-container--is-disabled{cursor:default;}}.c-react-select__menu{top:3.5rem;box-shadow:none;margin:0;}.c-react-select__menu-list{border:", " ", ";border-radius:", ";box-shadow:", ";padding:0;}.c-react-select__indicator{cursor:pointer;}.c-react-select__placeholder{", "}.c-react-select__indicator-separator{display:none;}.c-react-select__dropdown-indicator,.c-react-select__dropdown-indicator:hover{color:", ";}.c-react-select__clear-indicator,.c-react-select__clear-indicator:hover{color:", ";}.c-react-select__option{background-color:", ";color:", ";font-weight:", ";&:not(:first-child){border-top:", "  ", ";}}.c-react-select__option.c-react-select__option--is-selected{background-color:", ";color:", ";&:hover{background-color:", ";color:", ";}}.c-react-select__option--is-focused{background-color:", ";color:", ";}"], function (props) {
  return props.theme.primaryFont;
}, function (props) {
  return props.theme.standardPadding;
}, function (props) {
  return props.theme.thinLine;
}, function (props) {
  return props.hasErrors ? props.theme.c_foreground_danger : props.theme.c_foreground_primary;
}, function (props) {
  return props.theme.thickLine;
}, function (props) {
  return props.theme.thickLine;
}, function (props) {
  return props.hasErrors ? props.theme.c_foreground_danger : props.theme.c_foreground_primary;
}, function (props) {
  return props.theme.thinLine;
}, function (props) {
  return props.isSearchable ? 'text' : 'pointer';
}, function (props) {
  return props.theme.standardButtonBorder;
}, function (props) {
  return props.theme.c_clickable_primaryGhost_border;
}, function (props) {
  return props.theme.borderRadius;
}, function (props) {
  return props.theme.s_dropdown;
}, function (props) {
  return !props.isSearchable ? "color: ".concat(props.theme.c_foreground_default, ";") : '';
}, function (props) {
  return props.theme.c_clickable_primaryGhost_text;
}, function (props) {
  return props.theme.c_clickable_primaryGhost_text;
}, function (props) {
  return props.theme.c_clickable_primaryGhost_background;
}, function (props) {
  return props.theme.c_clickable_primaryGhost_text;
}, function (props) {
  return props.theme.primaryMedium;
}, function (props) {
  return props.theme.standardButtonBorder;
}, function (props) {
  return props.theme.c_clickable_primaryGhost_hover_background;
}, function (props) {
  return props.theme.c_clickable_primaryGhost_active_background;
}, function (props) {
  return props.theme.c_clickable_primaryGhost_active_text;
}, function (props) {
  return props.theme.c_clickable_primaryGhost_hover_background;
}, function (props) {
  return props.theme.c_clickable_primaryGhost_hover_text;
}, function (props) {
  return props.theme.c_clickable_primaryGhost_hover_background;
}, function (props) {
  return props.theme.c_clickable_primaryGhost_hover_text;
});
exports.StyledSelect = StyledSelect;

var StyledLabel = _styledComponents.default.label.withConfig({
  displayName: "Selectstyles__StyledLabel",
  componentId: "ntlyl5-2"
})(["font-weight:", ";line-height:1.1875rem;padding:", " 0;"], function (props) {
  return props.theme.primaryHeavy;
}, function (props) {
  return props.theme.standardPadding;
});

exports.StyledLabel = StyledLabel;